export const statusUser = [
  "Look at you and look at me",
  "Love you to the moon and back",
  "Sometimes words are not enough",
  "A day without you is always incomplete",
  "My real smile comes out when i am with you ♥",
  "Love is blind, Be careful",
  "Attraction is automatic, but love is a choice"
];
